/**
 * @generated SignedSource<<8ea2968e67315b2f9c1afaa1b5fb1ad9>>
 * @relayHash 524d9b91015a220d28a9534db14d8776
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 524d9b91015a220d28a9534db14d8776

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ErnestCcn",
    "kind": "LinkedField",
    "name": "ernestCcns",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ape",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "idcc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ccnRef",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortTitle",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CcnsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CcnsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "524d9b91015a220d28a9534db14d8776",
    "metadata": {},
    "name": "CcnsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "d904eabd51048bd8eaa20d69589ca111";

export default node;
